import React, { useEffect, useState } from 'react';
import { AXIOS } from './api';
import axios from 'axios';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import GridLoader from 'react-spinners/GridLoader';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Sidebar from './components/common/Sidebar';
import Login from './components/Login';
import './css/index.css';

import Test from './components/Test';

import GestionActivites from './components/GestionActivites';
import GestionOffres from './components/GestionOffres';
import GestionFormules from './components/GestionFormules';
import GestionAccessoires from './components/GestionAccessoires';
import Configurations from './components/Configurations';
import NewOffre from './components/NewOffre';
import NewFormule from './components/NewFormule';
import NewAccessoire from './components/NewAccessoire';
import UpdateActivite from './components/UpdateActivite';
import UpdateOffre from './components/UpdateOffre';
import UpdateFormule from './components/UpdateFormule';
import UpdateAccessoire from './components/UpdateAccessoire';
import GestionCodePromos from './components/GestionCodePromos';
import NewCodePromo from './components/NewCodePromo';
import UpdateCodePromo from './components/UpdateCodePromo';

import { signOutUser, setTimeoutId, timeStartCounter, setLoading, fetchActivites, fetchOffres, fetchFormules, fetchAccessoires, fetchArticles, fetchTaches, fetchRooms, fetchConfigurations, fetchCodePromos } from './redux/actions';

const App = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const location = useLocation();
    const [, page] = location.pathname.split('/');

    const { timeStart, timeoutId, currentUser, authenticated } = useSelector((state) => state.auth);
    const { fetch, loading } = useSelector((state) => state.config);
    const { firstName, lastName } = currentUser;

    // // START TIME COUNTER --------------------------
    // useEffect(() => {
    //     // Set a fake timeout to get the highest timeout id
    //     var highestTimeoutId = setTimeout(";")
    //     for (var i = 0; i < highestTimeoutId; i++) clearTimeout(i)
    //     if (authenticated) {
    //         if (timeoutId !== null) clearTimeout(timeoutId)
    //         const intervalId = setInterval(() => {
    //             console.log(moment(new Date()).diff(new Date(timeStart), 'seconds'))
    //             if (moment(new Date()).diff(new Date(timeStart), 'seconds') >= 60) {
    //                 history.push('/')
    //                 dispatch(signOutUser())
    //                 clearTimeout(intervalId)
    //             }
    //         }, 1000);
    //         dispatch(setTimeoutId(intervalId))
    //         console.log('INTERVAL : ', intervalId)
    //     }
    // }, [authenticated, timeStart])

    // useEffect(() => {
    //     if (authenticated) {
    //         dispatch(timeStartCounter(new Date()))
    //         document.addEventListener('click', () => dispatch(timeStartCounter(new Date())))
    //         document.addEventListener('keyup', () => dispatch(timeStartCounter(new Date())))
    //     }
    // }, [authenticated])

    // FETCH NODE API DATA
    useEffect(() => {
        if (!authenticated) return;
        (async () => {
            try {
                dispatch(setLoading(true));
                // FETCH OFFRES FROM DATABASE
                let res = await AXIOS.get(`/api/v1/activites`);
                dispatch(fetchActivites(res.data.data.activites));
                // FETCH OFFRES FROM DATABASE
                res = await AXIOS.get(`/api/v1/offres`);
                dispatch(fetchOffres(res.data.data.offres));
                // FETCH OFFRES FROM DATABASE
                res = await AXIOS.get(`/api/v1/formules`);
                dispatch(fetchFormules(res.data.data.formules));
                // FETCH ACCESSOIRES FROM DATABASE
                res = await AXIOS.get(`/api/v1/accessoires`);
                dispatch(fetchAccessoires(res.data.data.accessoires));
                // FETCH CODE PROMOS FROM DATABASE
                res = await AXIOS.get(`/api/v1/codepromos`);
                dispatch(fetchCodePromos(res.data.data.codepromos));
                // FETCH CONFIGURATIONS FROM DATABASE
                res = await AXIOS.get(`/api/v1/configurations`);
                dispatch(fetchConfigurations(res.data.data.configurations));
                window.scrollTo(0, 0);
                dispatch(setLoading(false));
            } catch (err) {
                dispatch(setLoading(false));
                console.log(err);
            }
        })();
    }, [fetch, authenticated]);

    // FETCH HEITZ API ARTICLES
    useEffect(() => {
        if (!authenticated) return;
        (async () => {
            try {
                dispatch(setLoading(true));

                // FETCH ARTICLES FROM HEITZ
                let res = await AXIOS.get(`/api/articles?_limit=2000&fields=id,name,category`);
                dispatch(fetchArticles(res.data));

                let res2 = await AXIOS.get(`/api/planning/configuration/tasks`);
                dispatch(fetchTaches(res2.data));

                // FETCH ROOMS FROM HEITZ
                res = await AXIOS.get(`/api/bonresto/zones`);
                dispatch(fetchRooms(res.data));

                dispatch(setLoading(false));
            } catch (err) {
                dispatch(setLoading(false));
                console.log(err);
            }
        })();
    }, [dispatch, authenticated]);

    return (
        <div className="container" style={{ display: 'flex', overflow: 'auto', position: 'relative' }}>
            <Route exact path="/" component={Login} />
            {/* <Route exact path="/" component={Test} /> */}

            <Route
                path="/(.+)"
                render={() => (
                    <>
                        <Sidebar />


                        <Route exact path="/activites">
                            {authenticated ? <GestionActivites /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/offres">
                            {authenticated ? <GestionOffres /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/formules">
                            {authenticated ? <GestionFormules /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/accessoires">
                            {authenticated ? <GestionAccessoires /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/configurations">
                            {authenticated ? <Configurations /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/codepromos">
                            {authenticated ? <GestionCodePromos /> : <Redirect to="/?authenticated=false" />}
                        </Route>

                        <Route exact path="/offre">
                            {authenticated ? <NewOffre /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/formule">
                            {authenticated ? <NewFormule /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/accessoire">
                            {authenticated ? <NewAccessoire /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/codepromo">
                            {authenticated ? <NewCodePromo /> : <Redirect to="/?authenticated=false" />}
                        </Route>

                        <Route exact path="/activite/:aid">
                            {authenticated ? <UpdateActivite /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/offre/:oid">
                            {authenticated ? <UpdateOffre /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/formule/:fid">
                            {authenticated ? <UpdateFormule /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/accessoire/:cid">
                            {authenticated ? <UpdateAccessoire /> : <Redirect to="/?authenticated=false" />}
                        </Route>
                        <Route exact path="/codepromos/:pid">
                            {authenticated ? <UpdateCodePromo /> : <Redirect to="/?authenticated=false" />}
                        </Route>

                        {loading && (
                            <div className="gestion__loadingWrapper">
                                <GridLoader size={15} color={'#FF5C00'} loading={true} />
                                <div className="gestion__loading">Loading...</div>
                            </div>
                        )}

                        {/* SHOW EMPLOYEE TAG NAME */}
                        {!['activites', 'configurations'].includes(page) && (
                            <div className="sidebar__profile">
                                <img style={{ marginBottom: '10px' }} className="sidebar__iconItem" style={{ width: '2.6rem', marginRight: '1rem' }} src="/img/icon/user.svg" />
                                {`${firstName} ${lastName}`}
                            </div>
                        )}
                    </>
                )}
            />
        </div>
    );
};

export default App;
